import { render, staticRenderFns } from "./ContaReceberManter.vue?vue&type=template&id=785b8b96&"
import script from "./ContaReceberManter.vue?vue&type=script&lang=js&"
export * from "./ContaReceberManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports